const padZero = (num, places) => String(num).padStart(places, "0");

export const formatDuration = duration =>
  `${padZero(duration.minutes(), 2)}:${padZero(duration.seconds(), 2)}`;
